import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import EditIcon from "@material-ui/icons/Edit";
import { Formik, Form, ErrorMessage } from "formik";
import axios from "axios";
import * as Yup from "yup";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { red } from "@material-ui/core/colors";
import SaveIcon from "@material-ui/icons/Save";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useSnackbar } from "notistack";

import { countries } from '../../../config/countries';

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  formControl: {
    marginBottom: theme.spacing(1.5),
  },
  redText: {
    color: red[800],
  },
}));

// ISO 3166-1 alpha-2
// ⚠️ No support for IE 11
function countryToFlag(isoCode) {
  return typeof String.fromCodePoint !== "undefined"
    ? isoCode
        .toUpperCase()
        .replace(/./g, (char) =>
          String.fromCodePoint(char.charCodeAt(0) + 127397)
        )
    : isoCode;
}

const CollectionPointSchema = Yup.object().shape({
  name: Yup.string().required("Name is required."),
  address_line_1: Yup.string().required("Address line  1 is required."),
  address_line_2: Yup.string(),
  county: Yup.string(),
  city: Yup.string().required("City is required."),
  postcode: Yup.string().required("Postcode is required."),
  country_code: Yup.string().required("Country is required."),
});

export default function CollectionPointEditForm({
  collectionPoint,
  updateCollectionPoint,
}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
 

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setLoading(false);
  };

  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    name: collectionPoint.name,
    address_line_1: collectionPoint.address_line_1,
    address_line_2: collectionPoint.address_line_2 ?? '',
    county: collectionPoint.county ?? '',
    city: collectionPoint.city,
    postcode: collectionPoint.postcode,
    country_code: collectionPoint.country_code,
    active: collectionPoint.active,
    note: collectionPoint.note,
  };

  return (
    <React.Fragment>
      <IconButton
        aria-label="edit"
        style={{ margin: 0 }}
        onClick={handleClickOpen}
      >
        <EditIcon fontSize="small" />
      </IconButton>

      <Formik
        initialValues={initialValues}
        validationSchema={CollectionPointSchema}
        onSubmit={(values, actions) => {
          setLoading(true);

          axios
            .put(`collection-points/${collectionPoint.id}`, values)
            .then((response) => {

              setLoading(false);
              actions.setSubmitting(false);
              //  actions.resetForm(true);
              setOpen(false);

              if (response.data && response.data.status) {
                enqueueSnackbar(`${response.data.message}`, {
                  variant: `${response.data.status}`,
                });
              }

              if (response.data && response.data.status === "success") {
                updateCollectionPoint(response.data.data);
              }
            })
            .catch(function (error) {

              setLoading(false);
              // actions.setErrors(error.response.data.errors);
              actions.setSubmitting(false);
            });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Edit Shipping Option
            </DialogTitle>


            <DialogContent dividers={true}>

            <FormControl fullWidth className={classes.formControl}>
                <TextField
                  name="name"
                  label="Name"
                  type="text"
                  value={values.name}
                  helperText={errors ? errors.name : ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    errors && errors.name && touched.name ? true : null
                  }
                />
              </FormControl>

              <FormControl fullWidth className={classes.formControl}>
                <TextField
                  name="address_line_1"
                  label="Address line 1"
                  type="text"
                  value={values.address_line_1}
                  helperText={errors ? errors.address_line_1 : ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    errors && errors.address_line_1 && touched.address_line_1 ? true : null
                  }
                />
              </FormControl>

              <FormControl fullWidth className={classes.formControl}>
                <TextField
                  name="address_line_2"
                  label="Address line 2"
                  type="text"
                  value={values.address_line_2}
                  helperText={errors ? errors.address_line_2 : ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    errors && errors.address_line_2 && touched.address_line_2 ? true : null
                  }
                />
              </FormControl>

              <FormControl fullWidth className={classes.formControl}>
                <TextField
                  name="county"
                  label="County"
                  type="text"
                  value={values.county}
                  helperText={errors ? errors.county : ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors && errors.county && touched.county ? true : null}
                />
              </FormControl>

              <FormControl fullWidth className={classes.formControl}>
                <TextField
                  name="city"
                  label="City"
                  type="text"
                  value={values.city}
                  helperText={errors ? errors.city : ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors && errors.city && touched.city ? true : null}
                />
              </FormControl>

              <FormControl fullWidth className={classes.formControl}>
                <TextField
                  name="postcode"
                  label="Postcode"
                  type="text"
                  value={values.postcode}
                  helperText={errors ? errors.postcode : ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors && errors.postcode && touched.postcode ? true : null}
                />
              </FormControl>

              <FormControl fullWidth className={classes.formControl} >
                  <Autocomplete
                  id="country_code"
                  name="country_code"
                  value={countries.find(country => country.code === values.country_code)}
                  options={countries}
                    getOptionLabel={(option) => option.label}
                    renderOption={(option) => (
                      <React.Fragment>
                        <span>{countryToFlag(option.code)}</span>
                        {option.label}
                      </React.Fragment>
                    )}
                    onChange={(e, value) => {
                      setFieldValue("country_code", value.code);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Country"
                        helperText={errors ? errors.country_code : ""}
                        onBlur={handleBlur}
                        error={
                          errors &&
                          errors.country_code &&
                          touched.country_code
                            ? true
                            : null
                        }
                      />
                    )}
                  />
                </FormControl>

                <FormControlLabel
                control={
                  <Checkbox
                    checked={values.active}
                    onChange={(e, value) => {
                      setFieldValue("active", value ? 1 : 0);
                    }}
                    name="active"
                    color="primary"
                  />
                }
                label="Active"
              />


              <FormControl fullWidth className={classes.formControl}>
                <TextField
                  multiline
                  rowsMax={4}
                  name="note"
                  label="Note"
                  type="text"
                  value={values.note}
                  helperText={errors ? errors.note : ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors && errors.note && touched.note ? true : null}
                />
              </FormControl>
            </DialogContent>
 
         
            <DialogActions>
              <Button onClick={handleClose} color="primary" variant="outlined">
                Cancel
              </Button>

              <Button
                color="primary"
                variant="outlined"
                disabled={loading}
                onClick={handleSubmit}
                startIcon={
                  loading ? <CircularProgress size={16} /> : <SaveIcon />
                }
              >
                {isSubmitting ? "Saving ..." : "Save"}
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Formik>
    </React.Fragment>
  );
}
